import request from '@/core/http/request'

//生成编号
export function sysNumber_queryNumberLength(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysNumber/sysNumber.queryNumberLength',
        method: 'post',
        data: data
    })
}

//新增自定义菜单
export function sysUserMenu_add(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysUserMenu/add',
        method: 'post',
        data: data
    })
}

//修改自定义菜单
export function sysUserMenu_update(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysUserMenu/update',
        method: 'post',
        data: data
    })
}

// 查询用户menu设置数据
export function sysUserMenu_query_setting(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysUserMenu/query.setting',
        method: 'post',
        data: data
    })
}

// 初始化数据
export function checkInitialization(data) {
    return request({
        url: '/admin/upms/login/checkInitialization',
        method: 'post',
        data: data
    })
}

// 修改密码
export function updatePassword(data) {
    return request({
        url: '/admin/upms/login/forgotPassword',
        method: 'post',
        data: data
    })
}

// 绑定手机号
export function bindPhone(data) {
    return request({
        url: '/admin/upms/login/bindPhone',
        method: 'post',
        data: data
    })
}

// 解绑手机号
export function unbindPhone(data) {
    return request({
        url: '/admin/upms/login/unbindPhone',
        method: 'post',
        data: data
    })
}

// 登录
export function buildPermissionMenu(data) {
    return request({
        url: '/admin/upms/login/buildPermissionMenu',
        method: 'get',
        params: data
    })
}

// 选择不同账户
export function chooseNameLogin(data) {
    return request({
        url: '/admin/upms/login/chooseNameLogin',
        method: 'post',
        data: data
    })
}

// 心跳包
export function heartbeat(data) {
    return request({
        url: '/admin/upms/login/heartbeat',
        method: 'post',
        data: data
    })
}

// 三大主体自定义字段
export function sysEntityExtControl_listByType(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysEntityExtControl/listByFilter',
        method: 'post',
        data: data
    })
}

// 三大主体新增自定义字段
export function sysEntityExtControl_add(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysEntityExtControl/add',
        method: 'post',
        data: data
    })
}

// 三大主体修改自定义字段
export function sysEntityExtControl_update(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysEntityExtControl/update',
        method: 'post',
        data: data
    })
}

// 查询订单自定义字段
export function sysDocExtControl_listByType(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysDocExtControl/listByFilter',
        method: 'post',
        data: data
    })
}

// 修改订单自定义字段
export function sysDocExtControl_update(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysDocExtControl/update',
        method: 'post',
        data: data
    })
}

// 打印模板列表
export function sysPrint_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysPrint/listByFilter',
        method: 'post',
        data: data
    })
}

// 新增打印模板
export function sysPrint_add(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysPrint/add',
        method: 'post',
        data: data
    })
}

// 修改打印模板
export function sysPrint_update(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysPrint/update',
        method: 'post',
        data: data
    })
}

// 打印模板详情
export function sysPrint_view(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysPrint/view',
        method: 'get',
        params: data
    })
}

// 打印模板删除
export function sysPrint_delete(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysPrint/delete',
        method: 'post',
        data: data
    })
}

// 打印修改默认
export function sysPrint_setDefault(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysPrint/setDefault',
        method: 'post',
        data: data
    })
}


// 打印修改默认
export function sysPrint_htmlToWord(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysPrint/htmlToWord',
        method: 'post',
        data: data
    })
}


// 查询默认打印模板
export function sysPrint_getDefaultByModules(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysPrint/getDefaultByModules',
        method: 'post',
        data: data
    })
}

// 添加打印记录
export function sysPrintHistoryContent_add(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysPrintHistoryContent/add',
        method: 'post',
        data: data
    })
}

// 打印记录
export function sysPrintHistoryContent_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysPrintHistoryContent/list',
        method: 'post',
        data: data
    })
}


function footerFormatter(options, rows, data, currentPageGridRowsData) {
    return `<tr><td colspan='100' style=\"padding:5px\">货到验明，收妥作实，如有错漏，请即通知。</td></tr>
    <tr><td colspan='3' style=\"padding:10px;font-size:11pt\">送货人：<br><br><br><br></td>
    <td colspan='6' style=\"padding:10px;font-size:11pt\">收货人(签名或盖章)：<br><br><br><br></td></tr>`;
}

// 审核配置
export function sysDocExamineConfig_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysDocExamineConfig/listV2',
        method: 'post',
        data: data
    })
}

// 修改审核配置
export function sysDocExamineConfig_update(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysDocExamineConfig/update',
        method: 'post',
        data: data
    })
}

// 查询是否能审核
export function sysDocExamineConfig_canCheckDocByDocType(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysDocExamineConfig/canCheckDocByDocType',
        method: 'post',
        data: data
    })
}

// 质检配置
export function sysQualityInspectionConfig_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysQualityInspectionConfig/list',
        method: 'post',
        data: data
    })
}

// 修改质检配置
export function sysQualityInspectionConfig_update(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysQualityInspectionConfig/update',
        method: 'post',
        data: data
    })
}

// 上传文件
export function upload(data) {
    return request({
        url: '/qingguang/tenantbussiness/common/upload',
        method: 'post',
        data: data
    })
}

//按钮配置 老
export function sysDocCirculationConfig_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysDocCirculationConfig/listByPageId',
        method: 'post',
        data: data
    })
}

//修改按钮配置
export function sysDocCirculationConfig_update(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysDocCirculationConfig/update',
        method: 'post',
        data: data
    })
}

//按钮配置 新
export function sysButtonConfig_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysButtonConfig/listByPageId',
        method: 'post',
        data: data
    })
}

//按钮配置 新
export function sysButtonConfig_update(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysButtonConfig/update',
        method: 'post',
        data: data
    })
}

//查询页面显示按钮(老接口)
export function sysDocCirculationConfig_listButtonCanShow(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysDocCirculationConfig/listButtonCanShow',
        method: 'post',
        data: data
    })
}

//查询页面显示按钮(新接口)
export function sysButtonConfig_listButtonCanShow(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysButtonConfig/listButtonCanShow',
        method: 'post',
        data: data
    })
}

// 根据页面ID查询列表背景颜色配置
export function sysBackgroundColorSetting_listByFilter(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysBackgroundColorSetting/listByFilter',
        method: 'post',
        data: data
    })
}

// 新增列表背景颜色配置
export function sysBackgroundColorSetting_add(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysBackgroundColorSetting/add',
        method: 'post',
        data: data
    })
}

// 修改列表背景颜色配置
export function sysBackgroundColorSetting_update(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysBackgroundColorSetting/update',
        method: 'post',
        data: data
    })
}

// 删除列表背景颜色配置
export function sysBackgroundColorSetting_delete(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysBackgroundColorSetting/delete',
        method: 'post',
        data: data
    })
}

//查询页面字段显示
export function field_show(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysEntityMainControl/listByTypeId',
        method: 'post',
        data: data
    })
}

//查询页面字段列表显示
export function field_showOnly(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysEntityMainControl/listShowByTypeId',
        method: 'post',
        data: data
    })
}

//查询页面字段显示更新
export function field_update(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysEntityMainControl/update',
        method: 'post',
        data: data
    })
}

// 建模引擎批量修改
export function sysEntityMainControl_updateBatch(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysEntityMainControl/updateBatch',
        method: 'post',
        data: data
    })
}

//查询页面必填字段显示校验
export function listRequired_showOnly(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysEntityMainControl/listRequiredByTypeId',
        method: 'post',
        data: data
    })
}

//获取客户物流信息
export function listByCustomerId(data) {
    return request({
        url: '/qingguang/tenantbussiness/customerShippingInfo/listByCustomerId',
        method: 'get',
        params: data
    })
}
//获取供应商物流信息
export function listBySupplierId(data) {
    return request({
        url: '/qingguang/tenantbussiness/supplierShippingInfo/listBySupplierId',
        method: 'get',
        params: data
    })
}

//获取特性编码开关
export function characteristicSwitch_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/characteristicSwitch/list',
        method: 'post',
        data: data
    })
}

//修改特性编码开关
export function characteristicSwitch_update(data) {
    return request({
        url: '/qingguang/tenantbussiness/characteristicSwitch/update',
        method: 'post',
        data: data
    })
}

//根据key获取
export function getCharacteristicSwitchByKey(data) {
    return request({
        url: '/qingguang/tenantbussiness/characteristicSwitch/getCharacteristicSwitchByKey',
        method: 'post',
        data: data
    })
}

// 根据文件ID获取新文件
export function fileInfo_getFileId(data) {
    return request({
        url: '/qingguang/tenantbussiness/fileInfo/getFileId',
        method: 'post',
        data: data
    })
}

// 修改单据自定义字段
export function sysDocExt_updateByRelId(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysDocExt/updateByRelId',
        method: 'post',
        data: data
    })
}

// 修改主体自定义字段
export function sysEntityExt_updateByRelId(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysEntityExt/updateByRelId',
        method: 'post',
        data: data
    })
}

// 编码引擎List接口
export function sysNumberConfig_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysNumberConfig/list',
        method: 'post',
        data: data
    })
}

// 编码引擎更新接口
export function sysNumberConfig_update(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysNumberConfig/update',
        method: 'post',
        data: data
    })
}

// 编码引擎预览
export function sysNumberConfig_snPreview(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysNumberConfig/snPreview',
        method: 'post',
        data: data
    })
}

// 新增页面缓存
export function sysDocCache_saveNewOrUpdate(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysDocCache/saveNewOrUpdate',
        method: 'post',
        data: data
    })
}

// 查询页面缓存
export function sysDocCache_getSysDocCacheVoByKey(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysDocCache/getSysDocCacheVoByKey',
        method: 'post',
        data: data
    })
}

// 全局搜索码更新
export function sysNumberConfig_creatSysNumber(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysNumberConfig/creatSysNumber',
        method: 'get',
        params: data
    })
}

// 进销存模块报价单待审核单据数量
export function selectSalesQuotationListCountWhileCheck(data) {
    return request({
        url: '/qingguang/tenantbussiness/smgtSalesQuotationDocDetail/selectSalesQuotationListCountWhileCheck',
        method: 'post',
        data: data
    })
}

// 进销存模块销售订单待审核单据数量
export function selectSalesOrderListCountWhileCheck(data) {
    return request({
        url: '/qingguang/tenantbussiness/smgtSalesOrderDocDetail/selectSalesOrderListCountWhileCheck',
        method: 'post',
        data: data
    })
}

// 进销存模块销售出库单待审核单据数量
export function selectSalesDeliveryListCountWhileCheck(data) {
    return request({
        url: '/qingguang/tenantbussiness/smgtSalesDeliveryDocDetail/selectSalesDeliveryListCountWhileCheck',
        method: 'post',
        data: data
    })
}

// 进销存模块销售退货单待审核单据数量
export function selectSalesChargebackOrderListCountWhileCheck(data) {
    return request({
        url: '/qingguang/tenantbussiness/smgtSalesChargebackDocDetail/selectSalesChargebackOrderListCountWhileCheck',
        method: 'post',
        data: data
    })
}

// 进销存模块销售账单待审核单据数量
export function getStatementDocListCountWhileCheck(data) {
    return request({
        url: '/qingguang/tenantbussiness/smgtSalesStatementDoc/getStatementDocListCountWhileCheck',
        method: 'post',
        data: data
    })
}

// 进销存模块样品单待审核单据数量
export function selectSalesSampleDocListCountWhileCheck(data) {
    return request({
        url: '/qingguang/tenantbussiness/smgtSalesSampleDocDetail/selectSalesSampleDocListCountWhileCheck',
        method: 'post',
        data: data
    })
}


// 进销存模块采购订单待审核单据数量
export function selectPurchasesOrderListCountWhileCheck(data) {
    return request({
        url: '/qingguang/tenantbussiness/pmgtPurchasesOrderDocDetail/selectPurchasesOrderListCountWhileCheck',
        method: 'post',
        data: data
    })
}

// 进销存模块采购入库单待审核单据数量
export function selectPurchasesReceiptListCountWhileCheck(data) {
    return request({
        url: '/qingguang/tenantbussiness/pmgtPurchasesReceiptDocDetail/selectPurchasesReceiptListCountWhileCheck',
        method: 'post',
        data: data
    })
}

// 进销存模块采购退货单待审核单据数量
export function getPurchasesChargebackOrderListCountWhileCheck(data) {
    return request({
        url: '/qingguang/tenantbussiness/pmgtPurchasesChargebackDocDetail/getPurchasesChargebackOrderListCountWhileCheck',
        method: 'post',
        data: data
    })
}

// 进销存模块请购单待审核单据数量
export function selectUnPurchasesRequisitionDocListCountWhileCheck(data) {
    return request({
        url: '/qingguang/tenantbussiness/pmgtPurchasesRequistionDoc/selectUnPurchasesRequisitionDocListCountWhileCheck',
        method: 'post',
        data: data
    })
}

// 进销存模块采购账单待审核单据数量
export function getPurchaseStatementDocListCountWhileCheck(data) {
    return request({
        url: '/qingguang/tenantbussiness/pmgtPurchasesStatementDoc/getPurchaseStatementDocListCountWhileCheck',
        method: 'post',
        data: data
    })
}

// 进销存模块请款单待审核单据数量
export function selectRequestFundsListCountWhileCheck(data) {
    return request({
        url: '/qingguang/tenantbussiness/requestFunds/selectRequestFundsListCountWhileCheck',
        method: 'post',
        data: data
    })
}

// 进销存模块报销单待审核单据数量
export function getReimburseDocListCountWhileCheck(data) {
    return request({
        url: '/qingguang/tenantbussiness/reimburseDoc/getReimburseDocListCountWhileCheck',
        method: 'post',
        data: data
    })
}

// 进销存模块精细报价单单待审核单据数量
export function selectFineQuotationDocListCountWhileCheck(data) {
    return request({
        url: '/qingguang/tenantbussiness/fineQuotationDocDetail/selectFineQuotationDocListCountWhileCheck',
        method: 'post',
        data: data
    })
}

// 首页未审核数据汇总（生产）
export function bom_getMesTotalCount(data) {
    return request({
        url: '/qingguang/tenantbussiness/bom/getMesTotalCount',
        method: 'post',
        data: data
    })
}

// 付款方式listby
export function sysPaymentListBy(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysPaymentMethodConfig/listBy',
        method: 'post',
        data: data
    })
}

// 付款方式Method       0.付款，1.收款
export function getSysPaymentMethodConfigListByTransactionMethod(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysPaymentMethodConfig/getSysPaymentMethodConfigListByTransactionMethod',
        method: 'post',
        data: data
    })
}

// 付款方式list
export function sysPaymentList(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysPaymentMethodConfig/list',
        method: 'post',
        data: data
    })
}

// 付款方式Add
export function sysPaymentAdd(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysPaymentMethodConfig/add',
        method: 'post',
        data: data
    })
}

// 付款方式update
export function sysPaymentUpdate(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysPaymentMethodConfig/update',
        method: 'post',
        data: data
    })
}

// 付款方式 delete
export function sysPaymentDelete(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysPaymentMethodConfig/delete',
        method: 'post',
        data: data
    })
}

// 批量下载文件
export function download_download(data) {
    return request({
        url: '/qingguang/tenantbussiness/download/download',
        method: 'post',
        data: data
    })
}

// 编号验证重复
export function sysGlobalNumber_canUseIndexDocNumber(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysGlobalNumber/canUseIndexDocNumber',
        method: 'get',
        params: data
    })
}

// 根据全局搜索码查询关联单据
export function sysGlobalNumber_getSysGlobalNumberInfoListByGlobalSearchNumber(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysGlobalNumber/getSysGlobalNumberInfoListByGlobalSearchNumber',
        method: 'post',
        data: data
    })
}

// 根据全局搜索码查询关联单据(画图)
export function sysDocRelation_getSysDocRelationListByIds(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysDocRelation/getSysDocRelationListByIds',
        method: 'post',
        data: data
    })
}

// 数据填报配置新增
export function sysTenantModelSetting_add(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysTenantModelSetting/add',
        method: 'post',
        data: data
    })
}

// 数据填报配置查询
export function sysTenantModelSetting_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysTenantModelSetting/list',
        method: 'post',
        data: data
    })
}

// 数据填报配置修改
export function sysTenantModelSetting_update(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysTenantModelSetting/update',
        method: 'post',
        data: data
    })
}

// 数据填报配置删除
export function sysTenantModelSetting_delete(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysTenantModelSetting/delete',
        method: 'post',
        data: data
    })
}

// 数据填报新增
export function sysTenantModelData_add(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysTenantModelData/add',
        method: 'post',
        data: data
    })
}

// 数据填报修改
export function sysTenantModelData_update(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysTenantModelData/update',
        method: 'post',
        data: data
    })
}

// 数据填报新增
export function sysTenantModelData_delete(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysTenantModelData/delete',
        method: 'post',
        data: data
    })
}

// 数据填报新增
export function sysTenantModelData_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysTenantModelData/list',
        method: 'post',
        data: data
    })
}

// 收支方式配置 查找
export function fnaAccountDetail_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/fnaAccountDetail/list',
        method: 'post',
        data: data
    })
}


// 收支方式配置 新增
export function fnaAccountDetail_add(data) {
    return request({
        url: '/qingguang/tenantbussiness/fnaAccountDetail/add',
        method: 'post',
        data: data
    })
}


// 收支方式配置 删除
export function fnaAccountDetail_delete(data) {
    return request({
        url: '/qingguang/tenantbussiness/fnaAccountDetail/delete',
        method: 'post',
        data: data
    })
}


// 收支方式配置 修改
export function fnaAccountDetail_update(data) {
    return request({
        url: '/qingguang/tenantbussiness/fnaAccountDetail/update',
        method: 'post',
        data: data
    })
}



// 首页
// 模块获取数据
export function sysWorkbench_getAdminWorkbench(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysWorkbench/getAdminWorkbench',
        method: 'post',
        data: data
    })
}

// 员工模块数据
export function sysUser_countWithUser(data) {
    return request({
        url: '/admin/upms/sysUser/countWithUser',
        method: 'post',
        data: data
    })
}
//  批量取消用户的授权
export function sysUser_batchCancelLogin(data) {
    return request({
        url: '/admin/upms/sysUser/batchCancelLogin',
        method: 'post',
        data: data
    })
}

// 用户离职
export function sysUser_userDimission(data) {
    return request({
        url: '/admin/upms/sysUser/userDimission',
        method: 'post',
        data: data
    })
}

// 用户复职
export function sysUser_userResume(data) {
    return request({
        url: '/admin/upms/sysUser/userResume',
        method: 'post',
        data: data
    })
}

// 日报提交查询
export function sysCheckConfig_getDailyCommitCount(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysCheckConfig/getDailyCommitCount',
        method: 'post',
        data: data
    })
}

// 待审核单据获取数据
export function sys_getUncheckCount(data) {
    return request({
        url: '/qingguang/tenantbussiness/sys/getUncheckCount',
        method: 'post',
        data: data
    })
}

// 常用入口查询
export function commonEntrance_view(data) {
    return request({
        url: '/qingguang/tenantbussiness/commonEntrance/view',
        method: 'get',
        params: data
    })
}

// 常用入口删除
export function commonEntrance_delete(data) {
    return request({
        url: '/qingguang/tenantbussiness/commonEntrance/delete',
        method: 'post',
        data: data
    })
}

// 常用入口新增
export function commonEntrance_add(data) {
    return request({
        url: '/qingguang/tenantbussiness/commonEntrance/add',
        method: 'post',
        data: data
    })
}

// 常用入口更新
export function commonEntrance_update(data) {
    return request({
        url: '/qingguang/tenantbussiness/commonEntrance/update',
        method: 'post',
        data: data
    })
}

// 获取销售排行数据
export function smgtSalesOrderDoc_groupByDocCount(data) {
    return request({
        url: '/qingguang/tenantbussiness/smgtSalesOrderDoc/groupByDocCount',
        method: 'post',
        data: data
    })
}
export function customer_groupByCustomerCount(data) {
    return request({
        url: '/qingguang/tenantbussiness/customer/groupByCustomerCount',
        method: 'post',
        data: data
    })
}
export function customerFollowUpRecord_groupByFollowUpRecord(data) {
    return request({
        url: '/qingguang/tenantbussiness/customerFollowUpRecord/groupByFollowUpRecord',
        method: 'post',
        data: data
    })
}

// 产品排行
export function smgtSalesStatementDocDetail_groupByMaterial(data) {
    return request({
        url: '/qingguang/tenantbussiness/smgtSalesStatementDocDetail/groupByMaterial',
        method: 'post',
        data: data
    })
}

// 我的日程
// 详情
export function scheduleDoc_view(data) {
    return request({
        url: '/qingguang/tenantbussiness/scheduleDoc/view',
        method: 'get',
        params: data
    })
}

// 列表
export function scheduleDoc_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/scheduleDoc/list',
        method: 'post',
        data: data
    })
}

// 修改
export function scheduleDoc_update(data) {
    return request({
        url: '/qingguang/tenantbussiness/scheduleDoc/update',
        method: 'post',
        data: data
    })
}

// 删除
export function scheduleDoc_delete(data) {
    return request({
        url: '/qingguang/tenantbussiness/scheduleDoc/delete',
        method: 'post',
        data: data
    })
}

// 删除整个日程
export function scheduleDoc_deleteByDate(data) {
    return request({
        url: '/qingguang/tenantbussiness/scheduleDoc/deleteByDate',
        method: 'post',
        data: data
    })
}

// 新增
export function scheduleDoc_add(data) {
    return request({
        url: '/qingguang/tenantbussiness/scheduleDoc/add',
        method: 'post',
        data: data
    })
}

// 规章公告
export function informNotice_listByMode(data) {
    return request({
        url: '/qingguang/tenantbussiness/informNotice/listByMode',
        method: 'post',
        data: data
    })
}

// 考勤相关
// 考勤信息
export function attendanceRecord_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/attendanceRecord/list',
        method: 'post',
        data: data
    })
}

export function attendanceRecord_saveNewOrUpdateBatch(data) {
    return request({
        url: '/qingguang/tenantbussiness/attendanceRecord/saveNewOrUpdateBatch',
        method: 'post',
        data: data
    })
}

// 考勤机信息查询
export function attendanceMachine_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/attendanceMachine/list',
        method: 'post',
        data: data
    })
}

// 考勤机信息添加
export function attendanceMachine_add(data) {
    return request({
        url: '/qingguang/tenantbussiness/attendanceMachine/add',
        method: 'post',
        data: data
    })
}

// 考勤机查看详情
export function attendanceMachine_view(data) {
    return request({
        url: '/qingguang/tenantbussiness/attendanceMachine/view',
        method: 'get',
        params: data
    })
}

// 考勤机信息修改
export function attendanceMachine_update(data) {
    return request({
        url: '/qingguang/tenantbussiness/attendanceMachine/update',
        method: 'post',
        data: data
    })
}

// 考勤机信息删除
export function attendanceMachine_delete(data) {
    return request({
        url: '/qingguang/tenantbussiness/attendanceMachine/delete',
        method: 'post',
        data: data
    })
}

// 员工启用考勤机
export function attendanceMachine_distributeEmployees(data) {
    return request({
        url: '/qingguang/tenantbussiness/attendanceMachine/distributeEmployees',
        method: 'post',
        data: data
    })
}

// 员工弃用考勤机
export function attendanceMachine_deleteEmployees(data) {
    return request({
        url: '/qingguang/tenantbussiness/attendanceMachine/deleteEmployees',
        method: 'post',
        data: data
    })
}

// 节假日日期
export function dateInform_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/dateInform/list',
        method: 'post',
        data: data
    })
}

// 节假日日期
export function dateInform_update(data) {
    return request({
        url: '/qingguang/tenantbussiness/dateInform/update',
        method: 'post',
        data: data
    })
}

// 考勤规则 班次查询
export function shift_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/qingguang/tenantbussiness/shift/list',
        method: 'post',
        data: data
    })
}

// 考勤规则 班次删除
export function shift_delete(data) {
    return request({
        url: '/qingguang/tenantbussiness/qingguang/tenantbussiness/shift/delete',
        method: 'post',
        data: data
    })
}
// 考勤规则 班次添加
export function shift_add(data) {
    return request({
        url: '/qingguang/tenantbussiness/qingguang/tenantbussiness/shift/add',
        method: 'post',
        data: data
    })
}

// 考勤规则 班次详情
export function shift_view(data) {
    return request({
        url: '/qingguang/tenantbussiness/qingguang/tenantbussiness/shift/view',
        method: 'get',
        params: data
    })
}

// 考勤规则 班次详情
export function shift_update(data) {
    return request({
        url: '/qingguang/tenantbussiness/qingguang/tenantbussiness/shift/update',
        method: 'post',
        data: data
    })
}

// 考勤记录 每天
export function attendanceUserCondition_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/attendanceUserCondition/list',
        method: 'post',
        data: data
    })
}

// 行政数据概览
export function getAdministrativeDataInfo(data) {
    return request({
        url: '/qingguang/tenantbussiness/attendanceUserCondition/getAdministrativeDataInfo',
        method: 'post',
        data: data
    })
}

// 考勤记录 每月
export function attendanceUserCondition_listForMonth(data) {
    return request({
        url: '/qingguang/tenantbussiness/attendanceUserCondition/listForMonth',
        method: 'post',
        data: data
    })
}

// 考勤记录 修改
export function attendanceUserCondition_update(data) {
    return request({
        url: '/qingguang/tenantbussiness/attendanceUserCondition/update',
        method: 'post',
        data: data
    })
}

// 考勤日报
export function attendanceUserCondition_getUserAttendanceOnTheDay(data) {
    return request({
        url: '/qingguang/tenantbussiness/attendanceUserCondition/getUserAttendanceOnTheDay',
        method: 'post',
        data: data
    })
}

// 考勤记录 删除
export function attendanceRecord_delete(data) {
    return request({
        url: '/qingguang/tenantbussiness/attendanceRecord/delete',
        method: 'post',
        data: data
    })
}

// 考勤记录 重新生成
export function attendanceUserCondition_rebuildAttendanceCondition(data) {
    return request({
        url: '/qingguang/tenantbussiness/attendanceUserCondition/rebuildAttendanceCondition',
        method: 'post',
        data: data
    })
}

// 请假 查询
export function attendanceLeave_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/attendanceLeave/list',
        method: 'post',
        data: data
    })
}

// 请假 新增
export function attendanceLeave_add(data) {
    return request({
        url: '/qingguang/tenantbussiness/attendanceLeave/add',
        method: 'post',
        data: data
    })
}

// 请假 删除
export function attendanceLeave_delete(data) {
    return request({
        url: '/qingguang/tenantbussiness/attendanceLeave/delete',
        method: 'post',
        data: data
    })
}

// 请假 更新
export function attendanceLeave_update(data) {
    return request({
        url: '/qingguang/tenantbussiness/attendanceLeave/update',
        method: 'post',
        data: data
    })
}

// 请假 审核
export function attendanceLeave_check(data) {
    return request({
        url: '/qingguang/tenantbussiness/attendanceLeave/check',
        method: 'post',
        data: data
    })
}

// 请假 详情
export function attendanceLeave_view(data) {
    return request({
        url: '/qingguang/tenantbussiness/attendanceLeave/view',
        method: 'get',
        params: data
    })
}

// 来源单据
export function sourceViewData_selectViewDataListBySourceRelIds(data) {
    return request({
        url: '/qingguang/tenantbussiness/sourceViewData/selectViewDataListBySourceRelIds',
        method: 'post',
        data: data
    })
}

// 根据来源单据编号查询 
export function sourceViewData_selectViewDataListBySourceDocNumber(data) {
    return request({
        url: '/qingguang/tenantbussiness/sourceViewData/selectViewDataListBySourceDocNumber',
        method: 'post',
        data: data
    })
}

// 来源单据
export function clearData(data) {
    return request({
        url: '/qingguang/tenantbussiness/sys/clearData',
        method: 'post',
        data: data
    })
}

// 删除全部重复规格组
export function maintainUniqueSpecGroups(data) {
    return request({
        url: '/qingguang/tenantbussiness/sys/maintainUniqueSpecGroups',
        method: 'post',
        data: data
    })
}

// 重新进行销售数据验算
export function dataValidation(data) {
    return request({
        url: '/qingguang/tenantbussiness/sys/dataSalesValidation',
        method: 'post',
        data: data
    })
}

// 重新进行采购数据验算
export function dataPurchasesValidation(data) {
    return request({
        url: '/qingguang/tenantbussiness/sys/dataPurchasesValidation',
        method: 'post',
        data: data
    })
}

// 重新进行采委外数据验算
export function dataOutsourcingValidation(data) {
    return request({
        url: '/qingguang/tenantbussiness/sys/dataOutsourcingValidation',
        method: 'post',
        data: data
    })
}


// 根据产品信息重刷单据信息
export function syncMaterialInfoToOrders(data) {
    return request({
        url: '/qingguang/tenantbussiness/material/syncMaterialInfoToOrders',
        method: 'post',
        data: data
    })
}

// 价格策略修复未税价格
export function sys_priceStrategyFixUntaxedPrice(data) {
    return request({
        url: '/qingguang/tenantbussiness/sys/priceStrategyFixUntaxedPrice',
        method: 'post',
        data: data
    })
}


// 根据出库单重算销单
export function sys_rebuildSalesOrderDocByOutboundOrder(data) {
    return request({
        url: '/qingguang/tenantbussiness/sys/rebuildSalesOrderDocByOutboundOrder',
        method: 'post',
        data: data
    })
}

// 根据入库单重算采单
export function sys_rebuildPurchasesOrderDocByInboundOrder(data) {
    return request({
        url: '/qingguang/tenantbussiness/sys/rebuildPurchasesOrderDocByInboundOrder',
        method: 'post',
        data: data
    })
}

// 未对账销单去重
export function sys_recalculateUnreconciledSalesOrderDoc(data) {
    return request({
        url: '/qingguang/tenantbussiness/sys/recalculateUnreconciledSalesOrderDoc',
        method: 'post',
        data: data
    })
}

// 未对账采单去重
export function sys_recalculateUnreconciledPurchasesOrderDoc(data) {
    return request({
        url: '/qingguang/tenantbussiness/sys/recalculateUnreconciledPurchasesOrderDoc',
        method: 'post',
        data: data
    })
}

// 修复库存价值
export function sys_fixInventoryValue(data) {
    return request({
        url: '/qingguang/tenantbussiness/sys/fixInventoryValue',
        method: 'post',
        data: data
    })
}

// 修复物料扣减成本
export function sys_fixMaterialConsumptionCost(data) {
    return request({
        url: '/qingguang/tenantbussiness/sys/fixMaterialConsumptionCost',
        method: 'post',
        data: data
    })
}

// 修复出库成本
export function sys_fixOutboundCost(data) {
    return request({
        url: '/qingguang/tenantbussiness/sys/fixOutboundCost',
        method: 'post',
        data: data
    })
}

// 修复考勤
export function sys_fixAttendanceRecordEmployeeId(data) {
    return request({
        url: '/qingguang/tenantbussiness/sys/fixAttendanceRecordEmployeeId',
        method: 'post',
        data: data
    })
}


// 规章公告配置
// 查询
export function informNoticeSetting_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/informNoticeSetting/list',
        method: 'post',
        data: data
    })
}

// 新增
export function informNoticeSetting_add(data) {
    return request({
        url: '/qingguang/tenantbussiness/informNoticeSetting/add',
        method: 'post',
        data: data
    })
}

// 删除
export function informNoticeSetting_delete(data) {
    return request({
        url: '/qingguang/tenantbussiness/informNoticeSetting/delete',
        method: 'post',
        data: data
    })
}

// 修改
export function informNoticeSetting_update(data) {
    return request({
        url: '/qingguang/tenantbussiness/informNoticeSetting/update',
        method: 'post',
        data: data
    })
}

// 详情
export function informNoticeSetting_view(data) {
    return request({
        url: '/qingguang/tenantbussiness/informNoticeSetting/view',
        method: 'get',
        params: data
    })
}

// 规章公告页面
// 查询
export function informNotice_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/informNotice/list',
        method: 'post',
        data: data
    })
}

// 新增
export function informNotice_add(data) {
    return request({
        url: '/qingguang/tenantbussiness/informNotice/add',
        method: 'post',
        data: data
    })
}

// 删除
export function informNotice_delete(data) {
    return request({
        url: '/qingguang/tenantbussiness/informNotice/delete',
        method: 'post',
        data: data
    })
}

// 修改
export function informNotice_update(data) {
    return request({
        url: '/qingguang/tenantbussiness/informNotice/update',
        method: 'post',
        data: data
    })
}

// 详情
export function informNotice_view(data) {
    return request({
        url: '/qingguang/tenantbussiness/informNotice/view',
        method: 'get',
        params: data
    })
}

// 审核 取消审核
export function informNotice_check(data) {
    return request({
        url: '/qingguang/tenantbussiness/informNotice/check',
        method: 'post',
        data: data
    })
}

// 详情
export function informNotice_release(data) {
    return request({
        url: '/qingguang/tenantbussiness/informNotice/release',
        method: 'post',
        data: data
    })
}

// 取消发布
export function informNotice_cancelRelease(data) {
    return request({
        url: '/qingguang/tenantbussiness/informNotice/cancelRelease',
        method: 'post',
        data: data
    })
}

// 自定义列表历史记录新增
export function sysUserMenuCache_add(data) {
    return request({
        url: '/qingguang/tenantbussiness/qingguang/tenantbussiness/sysUserMenuCache/add',
        method: 'post',
        data: data
    })
}

// 自定义列表查询
export function sysUserMenuCache_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/qingguang/tenantbussiness/sysUserMenuCache/list',
        method: 'post',
        data: data
    })
}

// 流程详情
export function flowOperation_viewFlowProcessAndTaskList(data) {
    return request({
        url: '/admin/flow/flowOperation/viewFlowProcessAndTaskList',
        method: 'post',
        data: data
    })
}

// AI发信息
export function ai_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/ai/list',
        method: 'post',
        data: data
    })
}

// AI排产
export function ai_planScheduleAiCheck(data) {
    return request({
        url: '/qingguang/tenantbussiness/ai/planScheduleAiCheck',
        method: 'get',
        params: data
    })
}

// 各类报表
// 销售报表
export function smgtSalesOrderDoc_getSalesStatementList(data) {
    return request({
        url: '/qingguang/tenantbussiness/smgtSalesOrderDoc/getSalesStatementList',
        method: 'post',
        data: data
    })
}
// 销售利润报表
export function smgtSalesOrderDoc_getSalesProfitStatement(data) {
    return request({
        url: '/qingguang/tenantbussiness/smgtSalesOrderDoc/getSalesProfitStatement',
        method: 'post',
        data: data
    })
}
// 采购报表
export function pmgtPurchasesOrderDoc_getPurchasesStatementList(data) {
    return request({
        url: '/qingguang/tenantbussiness/pmgtPurchasesOrderDoc/getPurchasesStatementList',
        method: 'post',
        data: data
    })
}
// 库存报表相关
export function warehouseInventory_queryWmsReportListInfo(data) {  // 列表所需
    return request({
        url: '/qingguang/tenantbussiness/warehouseInventory/queryWmsReportListInfo',
        method: 'post',
        data: data
    })
}
export function warehouseInventory_queryWmsReportTotalInfo(data) {  // 模块所需
    return request({
        url: '/qingguang/tenantbussiness/warehouseInventory/queryWmsReportTotalInfo',
        method: 'post',
        data: data
    })
}
// 产品采购报表
export function pmgtPurchasesOrderDoc_getMaterialPurchasesStatementList(data) {
    return request({
        url: '/qingguang/tenantbussiness/pmgtPurchasesOrderDoc/getMaterialPurchasesStatementList',
        method: 'post',
        data: data
    })
}
// 产品报表
export function material_getMaterialStatementList(data) {
    return request({
        url: '/qingguang/tenantbussiness/material/getMaterialStatementList',
        method: 'post',
        data: data
    })
}
// 生产报表
export function produceDoc_listSum(data) {  // 汇总数据
    return request({
        url: '/qingguang/tenantbussiness/produceDoc/listSum',
        method: 'post',
        data: data
    })
}
// 客户报表
export function customer_getCustomerStatementList(data) {
    return request({
        url: '/qingguang/tenantbussiness/customer/getCustomerStatementList',
        method: 'post',
        data: data
    })
}

// 查询价格策略列表
export function sysPriceStrategyConfig_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysPriceStrategyConfig/list',
        method: 'post',
        data: data
    })
}

// 新增价格策略
export function sysPriceStrategyConfig_add(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysPriceStrategyConfig/add',
        method: 'post',
        data: data
    })
}

// 修改价格策略
export function sysPriceStrategyConfig_update(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysPriceStrategyConfig/update',
        method: 'post',
        data: data
    })
}

// 新增价格策略
export function sysPriceStrategyConfig_delete(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysPriceStrategyConfig/delete',
        method: 'post',
        data: data
    })
}

// 默认值配置 list
export function defaultConfig_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/defaultConfig/list',
        method: 'post',
        data: data
    })
}

// 默认值配置 update
export function defaultConfig_update(data) {
    return request({
        url: '/qingguang/tenantbussiness/defaultConfig/update',
        method: 'post',
        data: data
    })
}

// 默认值配置 view
export function defaultConfig_view(data) {
    return request({
        url: '/qingguang/tenantbussiness/defaultConfig/view',
        method: 'get',
        params: data
    })
}



// 授权用户统计
export function sysUser_getTenantAuthorizationAmount(data) {
    return request({
        url: '/admin/upms/sysUser/getTenantAuthorizationAmount',
        method: 'post',
        data: data
    })
}

// 报工账户统计
export function sysUser_getTenantReportAuthorizationAmount(data) {
    return request({
        url: '/admin/upms/sysUser/getTenantReportAuthorizationAmount',
        method: 'post',
        data: data
    })
}

// 基础工资表 saveNewOrUpdateBatch
export function basicAttendanceSalary_saveNewOrUpdateBatch(data) {
    return request({
        url: '/qingguang/tenantbussiness/qingguang/tenantbussiness/basicAttendanceSalary/saveNewOrUpdateBatch',
        method: 'post',
        data: data
    })
}

// 基础工资表 list
export function basicAttendanceSalary_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/qingguang/tenantbussiness/basicAttendanceSalary/list',
        method: 'post',
        data: data
    })
}

// 基础工资表 delete
export function basicAttendanceSalary_delete(data) {
    return request({
        url: '/qingguang/tenantbussiness/qingguang/tenantbussiness/basicAttendanceSalary/delete',
        method: 'post',
        data: data
    })
}

// 基础工资表 update
export function basicAttendanceSalary_update(data) {
    return request({
        url: '/qingguang/tenantbussiness/qingguang/tenantbussiness/basicAttendanceSalary/update',
        method: 'post',
        data: data
    })
}

// 工资表 年度
export function salary_salaryStatement(data) {
    return request({
        url: '/qingguang/tenantbussiness/qingguang/tenantbussiness/salary/salaryStatement',
        method: 'post',
        data: data
    })
}

// 工资表 重构
export function salary_rebuildSalary(data) {
    return request({
        url: '/qingguang/tenantbussiness/qingguang/tenantbussiness/salary/rebuildSalary',
        method: 'post',
        data: data
    })
}

// 工资表 个人list
export function salary_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/qingguang/tenantbussiness/salary/list',
        method: 'post',
        data: data
    })
}

// 工资表 view
export function salary_view(data) {
    return request({
        url: '/qingguang/tenantbussiness/qingguang/tenantbussiness/salary/view',
        method: 'get',
        params: data
    })
}

// 通知管理 列表
export function sysDocInformConfig_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysDocInformConfig/list',
        method: 'post',
        data: data
    })
}

// 通知管理 修改
export function sysDocInformConfig_update(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysDocInformConfig/update',
        method: 'post',
        data: data
    })
}

// 全局搜索码单据类型
export function sysGlobalNumber_getSysGlobalNumberInfoListOrderTypeByGlobalSearchNumber(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysGlobalNumber/getSysGlobalNumberInfoListOrderTypeByGlobalSearchNumber',
        method: 'post',
        data: data
    })
}

// 字段匹配配置
// 列表
export function sysExtTransConfig_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysExtTransConfig/list',
        method: 'post',
        data: data
    })
}

// 新增
export function sysExtTransConfig_add(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysExtTransConfig/add',
        method: 'post',
        data: data
    })
}

// 删除
export function sysExtTransConfig_delete(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysExtTransConfig/delete',
        method: 'post',
        data: data
    })
}

// 修改
export function sysExtTransConfig_update(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysExtTransConfig/update',
        method: 'post',
        data: data
    })
}

// 预警通知配置 列表
export function sysAlertNotificationEngine_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysAlertNotificationEngine/list',
        method: 'post',
        data: data
    })
}

// 预警通知配置 修改
export function sysAlertNotificationEngine_update(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysAlertNotificationEngine/update',
        method: 'post',
        data: data
    })
}

// 预警通知配置 删除
export function sysAlertNotificationEngine_delete(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysAlertNotificationEngine/delete',
        method: 'post',
        data: data
    })
}

// 预警通知配置 新增
export function sysAlertNotificationEngine_add(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysAlertNotificationEngine/add',
        method: 'post',
        data: data
    })
}

// 上传
export function common_uploadDoc(data) {
    return request({
        url: '/qingguang/tenantbussiness/common/uploadDoc',
        method: 'post',
        data: data
    })
}

// 选择excel模板打印
export function sysPrint_printfTemplateExcelForSys(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysPrint/printfTemplateExcelForSys',
        method: 'post',
        data: data
    })
}

// 预警信息 列表
export function sysAlertInfo_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysAlertInfo/list',
        method: 'post',
        data: data
    })
}

// 工资 批量修改
export function salary_updateBatch(data) {
    return request({
        url: '/qingguang/tenantbussiness/qingguang/tenantbussiness/salary/updateBatch',
        method: 'post',
        data: data
    })
}

// 主表改备注接口
// 0 销售  1 采购  2 生产
export function docFollowupRecord_updateRemarkById(data) {
    return request({
        url: '/qingguang/tenantbussiness/docFollowupRecord/updateRemarkById',
        method: 'post',
        data: data
    })
}

// 状态配置查询
export function sysStatusConfig_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysStatusConfig/list',
        method: 'post',
        data: data
    })
}

// 加班申请 列表
export function overtimeApplication_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/overtimeApplication/list',
        method: 'post',
        data: data
    })
}

// 状态配置新增
export function sysStatusConfig_add(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysStatusConfig/add',
        method: 'post',
        data: data
    })
}
// 加班申请 新增
export function overtimeApplication_add(data) {
    return request({
        url: '/qingguang/tenantbussiness/overtimeApplication/add',
        method: 'post',
        data: data
    })
}

// 状态配置修改
export function sysStatusConfig_update(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysStatusConfig/update',
        method: 'post',
        data: data
    })
}

// 加班申请 修改
export function overtimeApplication_update(data) {
    return request({
        url: '/qingguang/tenantbussiness/overtimeApplication/update',
        method: 'post',
        data: data
    })
}

// 状态配置删除
export function sysStatusConfig_delete(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysStatusConfig/delete',
        method: 'post',
        data: data
    })
}

// 加班申请 查询
export function overtimeApplication_view(data) {
    return request({
        url: '/qingguang/tenantbussiness/overtimeApplication/view',
        method: 'get',
        params: data
    })
}

// 加班申请 审核
export function overtimeApplication_check(data) {
    return request({
        url: '/qingguang/tenantbussiness/overtimeApplication/check',
        method: 'post',
        data: data
    })
}

// 多币种列表
export function fnaCurrency_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/fnaCurrency/list',
        method: 'post',
        data: data
    })
}

// 汇率
export function fnaExchangeRate_getExchangeRate(data) {
    return request({
        url: '/qingguang/tenantbussiness/fnaExchangeRate/getExchangeRate',
        method: 'post',
        data: data
    })
}

// 导入任务 列表
export function importTask_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/importTask/list',
        method: 'post',
        data: data
    })
}

// 导入任务 删除
export function importTask_delete(data) {
    return request({
        url: '/qingguang/tenantbussiness/importTask/delete',
        method: 'post',
        data: data
    })
}

// 导入任务 删除
export function importTask_view(data) {
    return request({
        url: '/qingguang/tenantbussiness/importTask/view',
        method: 'get',
        params: data
    })
}

// 考勤规则设置默认
export function shift_setAsDefault(data) {
    return request({
        url: '/qingguang/tenantbussiness/qingguang/tenantbussiness/shift/setAsDefault',
        method: 'post',
        data: data
    })
}

// 业财融合
// 列表
export function voucherConfig_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/voucherConfig/list',
        method: 'post',
        data: data
    })
}

// 新增
export function voucherConfig_add(data) {
    return request({
        url: '/qingguang/tenantbussiness/voucherConfig/add',
        method: 'post',
        data: data
    })
}

// 修改
export function voucherConfig_update(data) {
    return request({
        url: '/qingguang/tenantbussiness/voucherConfig/update',
        method: 'post',
        data: data
    })
}

// 删除
export function voucherConfig_delete(data) {
    return request({
        url: '/qingguang/tenantbussiness/voucherConfig/delete',
        method: 'post',
        data: data
    })
}

// voucherRecord 接口
export function voucherRecord_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/voucherRecord/list',
        method: 'post',
        data: data
    })
}

// 财务的summary
export function voucher_summary(data) {
    return request({
        url: '/financial/voucher/summary',
        method: 'get',
        params: data
    })
}
// 财务的select
export function voucher_select(data) {
    return request({
        url: 'financial/subject/voucher/select',
        method: 'get',
        params: data
    })
}
// 财务的type
export function voucher_word(data) {
    return request({
        url: 'financial/voucher-word',
        method: 'get',
        params: data
    })
}

// 用户角色管理权限判断
export function sysUser_checkUserRole(data) {
    return request({
        url: '/admin/upms/sysUser/checkUserRole',
        method: 'post',
        data: data
    })
}

// 打印ids存储
export function sysPrintDoc_add(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysPrintDoc/add',
        method: 'post',
        data: data
    })
}

// 源头字段映射配置 list
export function sourceFieldMappingConfig_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/sourceFieldMappingConfig/list',
        method: 'post',
        data: data
    })
}

// 源头字段映射配置 add
export function sourceFieldMappingConfig_add(data) {
    return request({
        url: '/qingguang/tenantbussiness/sourceFieldMappingConfig/add',
        method: 'post',
        data: data
    })
}

// 源头字段映射配置 update
export function sourceFieldMappingConfig_update(data) {
    return request({
        url: '/qingguang/tenantbussiness/sourceFieldMappingConfig/update',
        method: 'post',
        data: data
    })
}

// 源头字段映射配置 delete
export function sourceFieldMappingConfig_delete(data) {
    return request({
        url: '/qingguang/tenantbussiness/sourceFieldMappingConfig/delete',
        method: 'post',
        data: data
    })
}

// 审核单列表
export function orderModifyAudit_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/orderModifyAudit/list',
        method: 'post',
        data: data
    })
}

// 价格梯度 list
export function priceTiersConfig_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/priceTiersConfig/list',
        method: 'post',
        data: data
    })
}

// 审核单新增
export function orderModifyAudit_add(data) {
    return request({
        url: '/qingguang/tenantbussiness/orderModifyAudit/add',
        method: 'post',
        data: data
    })
}

// 价格梯度 add
export function priceTiersConfig_add(data) {
    return request({
        url: '/qingguang/tenantbussiness/priceTiersConfig/add',
        method: 'post',
        data: data
    })
}

// 审核单修改
export function orderModifyAudit_update(data) {
    return request({
        url: '/qingguang/tenantbussiness/orderModifyAudit/update',
        method: 'post',
        data: data
    })
}

// 价格梯度 delete
export function priceTiersConfig_delete(data) {
    return request({
        url: '/qingguang/tenantbussiness/priceTiersConfig/delete',
        method: 'post',
        data: data
    })
}

// 审核单删除
export function orderModifyAudit_delete(data) {
    return request({
        url: '/qingguang/tenantbussiness/orderModifyAudit/delete',
        method: 'post',
        data: data
    })
}

// 审核单详情
export function orderModifyAudit_view(data) {
    return request({
        url: '/qingguang/tenantbussiness/orderModifyAudit/view',
        method: 'get',
        params: data
    })
}

// 审核单审核
export function orderModifyAudit_check(data) {
    return request({
        url: '/qingguang/tenantbussiness/orderModifyAudit/check',
        method: 'post',
        data: data
    })
}

// 价格梯度 update
export function priceTiersConfig_update(data) {
    return request({
        url: '/qingguang/tenantbussiness/priceTiersConfig/update',
        method: 'post',
        data: data
    })
}

// 更新记录
export function publish_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/publish/list',
        method: 'post',
        data: data
    })
}

// 获取验证码
export function sendPhoneVerify(data) {
    return request({
        url: '/Home/SendPhoneVerify',
        method: 'post',
        data: data
    })
}

// 公式新增
export function sysFiledFormulaConfig_add(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysFiledFormulaConfig/add',
        method: 'post',
        data: data
    })
}

// 公式修改
export function sysFiledFormulaConfig_update(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysFiledFormulaConfig/update',
        method: 'post',
        data: data
    })
}

// 公式删除
export function sysFiledFormulaConfig_delete(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysFiledFormulaConfig/delete',
        method: 'post',
        data: data
    })
}

// 公式列表
export function sysFiledFormulaConfig_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysFiledFormulaConfig/list',
        method: 'post',
        data: data
    })
}

// 缓存主体自定义字段
export function sysEntityExtControl_batchQueryGroupByExtType(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysEntityExtControl/batchQueryGroupByExtType',
        method: 'post',
        data: data
    })
}

// 缓存单据自定义字段
export function sysDocExtControl_batchQueryGroupByExtType(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysDocExtControl/batchQueryGroupByExtType',
        method: 'post',
        data: data
    })
}

// 缓存字典
export function globalDict_listWithItems(data) {
    return request({
        url: '/admin/upms/globalDict/listWithItems',
        method: 'post',
        data: data
    })
}

// 未离职的人员
export function sysUser_listUserSimple(data) {
    return request({
        url: '/admin/upms/sysUser/listUserSimple',
        method: 'post',
        data: data
    })
}

// 导出引擎 列表
export function sysExportModelConfig_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysExportModelConfig/list',
        method: 'post',
        data: data
    })
}

// 导出引擎 新增
export function sysExportModelConfig_add(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysExportModelConfig/add',
        method: 'post',
        data: data
    })
}

// 导出引擎 更改
export function sysExportModelConfig_update(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysExportModelConfig/update',
        method: 'post',
        data: data
    })
}

// 导出引擎 删除
export function sysExportModelConfig_delete(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysExportModelConfig/delete',
        method: 'post',
        data: data
    })
}

//   根据页面唯一值查询导出路径
export function sysExportModelConfig_listByPageId(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysExportModelConfig/listByPageId',
        method: 'post',
        data: data
    })
}

//   根据页面唯一值查询导出路径
export function sys_replaceSpecGroupId(data) {
    return request({
        url: '/qingguang/tenantbussiness/sys/replaceSpecGroupId',
        method: 'post',
        data: data
    })
}

// 员工交接记录
export function sysHandover_list(data) {
    return request({
        url: '/admin/upms/sysHandover/list',
        method: 'post',
        data: data
    })
}

// 第三方平台配置 list
export function platformConfig_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/platformConfig/list',
        method: 'post',
        data: data
    })
}

// 第三方平台配置 add
export function platformConfig_add(data) {
    return request({
        url: '/qingguang/tenantbussiness/platformConfig/add',
        method: 'post',
        data: data
    })
}

// 第三方平台配置 update        
export function platformConfig_update(data) {
    return request({
        url: '/qingguang/tenantbussiness/platformConfig/update',
        method: 'post',
        data: data
    })
}

// 第三方平台配置 delete
export function platformConfig_delete(data) {
    return request({
        url: '/qingguang/tenantbussiness/platformConfig/delete',
        method: 'post',
        data: data
    })
}

// 产品溯源 获取批次号基本数据
export function productTrace_queryTraceSourceBaseData(data) {
    return request({
        url: '/qingguang/tenantbussiness/productTrace/queryTraceSourceBaseData',
        method: 'post',
        data: data
    })
}

// 产品溯源 生产记录
export function productTrace_queryBatchTraceInfo(data) {
    return request({
        url: '/qingguang/tenantbussiness/productTrace/queryBatchTraceInfo',
        method: 'post',
        data: data
    })
}

// 产品溯源 委外记录
export function productTrace_queryBatchOutsourcingRecords(data) {
    return request({
        url: '/qingguang/tenantbussiness/productTrace/queryBatchOutsourcingRecords',
        method: 'post',
        data: data
    })
}

// 产品溯源 原材料域供应商
export function productTrace_queryBatchInboundRecords(data) {
    return request({
        url: '/qingguang/tenantbussiness/productTrace/queryBatchInboundRecords',
        method: 'post',
        data: data
    })
}

// 产品溯源 库存与去向 - 销售出库+其他出库记录
export function productTrace_queryBatchOutboundRecords(data) {
    return request({
        url: '/qingguang/tenantbussiness/productTrace/queryBatchOutboundRecords',
        method: 'post',
        data: data
    })
}

// 产品溯源 库存与去向 - 在库库存分布
export function productTrace_queryBatchInventoryInfo(data) {
    return request({
        url: '/qingguang/tenantbussiness/productTrace/queryBatchInventoryInfo',
        method: 'post',
        data: data
    })
}

// 产品溯源 物料追溯 1
export function productTrace_queryProduceDocRelatedOrders(data) {
    return request({
        url: '/qingguang/tenantbussiness/productTrace/queryProduceDocRelatedOrders',
        method: 'post',
        data: data
    })
}

// 产品溯源 物料追溯 2
export function productTrace_queryProduceDocRelations(data) {
    return request({
        url: '/qingguang/tenantbussiness/productTrace/queryProduceDocRelations',
        method: 'post',
        data: data
    })
}

// 异步任务表
export function asyncTask_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/asyncTask/list',
        method: 'post',
        data: data
    })
}

// 异步任务表 删除
export function asyncTask_delete(data) {
    return request({
        url: '/qingguang/tenantbussiness/asyncTask/delete',
        method: 'post',
        data: data
    })
}

// 搜索方案 list
export function sysDocSearchFilter_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysDocSearchFilter/list',
        method: 'post',
        data: data
    })
}

// 搜索方案 add
export function sysDocSearchFilter_add(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysDocSearchFilter/add',
        method: 'post',
        data: data
    })
}

// 搜索方案 delete
export function sysDocSearchFilter_delete(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysDocSearchFilter/delete',
        method: 'post',
        data: data
    })
}

// 搜索方案 update
export function sysDocSearchFilter_update(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysDocSearchFilter/update',
        method: 'post',
        data: data
    })
}

// 文件归集表 list
export function sysDocFileCollection_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysDocFileCollection/list',
        method: 'post',
        data: data
    })
}

// 文件归集表 delete
export function sysDocFileCollection_delete(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysDocFileCollection/delete',
        method: 'post',
        data: data
    })
}

// 文件归集表 add
export function sysDocFileCollection_add(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysDocFileCollection/add',
        method: 'post',
        data: data
    })
}

// 文件归集表 update
export function sysDocFileCollection_update(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysDocFileCollection/update',
        method: 'post',
        data: data
    })
}

// 文件归集 根据采购帐单id查询文件
export function sysDocFileCollection_getFilesByPurchasesStatementDocId(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysDocFileCollection/getFilesByPurchasesStatementDocId',
        method: 'post',
        data: data
    })
}

// 文件归集 根据销售帐单id查询文件
export function sysDocFileCollection_getFilesBySalesStatementDocId(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysDocFileCollection/getFilesBySalesStatementDocId',
        method: 'post',
        data: data
    })
}

// AI自定义报表新增
export function customReport_customReport(data) {
    return request({
        url: '/qingguang/tenantbussiness/customReport/customReport',
        method: 'post',
        data: data
    })
}

// AI自定义报表修改
export function customReport_updateConfig(data) {
    return request({
        url: '/qingguang/tenantbussiness/customReport/updateConfig',
        method: 'post',
        data: data
    })
}

// AI自定义报表删除
export function customReport_delete(data) {
    return request({
        url: '/qingguang/tenantbussiness/customReport/delete',
        method: 'post',
        data: data
    })
}

// AI自定义报表列表
export function customReport_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/customReport/list',
        method: 'post',
        data: data
    })
}

// AI自定义报表详情
export function customReport_view(data) {
    return request({
        url: '/qingguang/tenantbussiness/customReport/view',
        method: 'get',
        params: data
    })
}

// AI自定义报表重新生成
export function customReport_regenerateConfig(data) {
    return request({
        url: '/qingguang/tenantbussiness/customReport/regenerateConfig',
        method: 'post',
        data: data
    })
}

// 发送站内信
export function userMessage_sendInternalMessage(data) {
    return request({
        url: '/qingguang/tenantbussiness/userMessage/sendInternalMessage',
        method: 'post',
        data: data
    })
}

// 项目类型配置 list
export function projectType_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/projectType/list',
        method: 'post',
        data: data
    })
}

// 项目类型配置 add
export function projectType_add(data) {
    return request({
        url: '/qingguang/tenantbussiness/projectType/add',
        method: 'post',
        data: data
    })
}

// 项目类型配置 update
export function projectType_update(data) {
    return request({
        url: '/qingguang/tenantbussiness/projectType/update',
        method: 'post',
        data: data
    })
}

// 项目类型配置 delete 
export function projectType_delete(data) {
    return request({
        url: '/qingguang/tenantbussiness/projectType/delete',
        method: 'post',
        data: data
    })
}

// 项目阶段配置 list
export function projectPhase_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/projectPhase/list',
        method: 'post',
        data: data
    })
}

// 项目阶段配置 add
export function projectPhase_add(data) {
    return request({
        url: '/qingguang/tenantbussiness/projectPhase/add',
        method: 'post',
        data: data
    })
}

// 项目阶段配置 update
export function projectPhase_update(data) { 
    return request({
        url: '/qingguang/tenantbussiness/projectPhase/update',
        method: 'post',
        data: data
    })
}

// 项目阶段配置 delete
export function projectPhase_delete(data) {
    return request({
        url: '/qingguang/tenantbussiness/projectPhase/delete',
        method: 'post',
        data: data
    })
}

// 项目模版配置 list
export function projectTemplate_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/projectTemplate/list',
        method: 'post',
        data: data
    })
}

// 项目模版配置 add
export function projectTemplate_add(data) {
    return request({
        url: '/qingguang/tenantbussiness/projectTemplate/add',
        method: 'post',
        data: data
    })
}

// 项目模版配置 update
export function projectTemplate_update(data) {
    return request({    
        url: '/qingguang/tenantbussiness/projectTemplate/update',
        method: 'post',
        data: data
    })
}

// 项目模版配置 delete
export function projectTemplate_delete(data) {
    return request({
        url: '/qingguang/tenantbussiness/projectTemplate/delete',
        method: 'post',
        data: data
    })
}

// 项目模版配置 view
export function projectTemplate_view(data) {
    return request({
        url: '/qingguang/tenantbussiness/projectTemplate/view',
        method: 'get',
        params: data
    })
}

// 项目阶段配置管理 list
export function projectConfiguration_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/projectConfiguration/list',
        method: 'post',
        data: data
    })
}

// 项目阶段配置管理 add
export function projectConfiguration_add(data) {
    return request({
        url: '/qingguang/tenantbussiness/projectConfiguration/add',
        method: 'post',
        data: data
    })
}

// 项目阶段配置管理 update
export function projectConfiguration_update(data) {
    return request({    
        url: '/qingguang/tenantbussiness/projectConfiguration/update',
        method: 'post',
        data: data
    })
}

// 项目阶段配置管理 delete
export function projectConfiguration_delete(data) {
    return request({
        url: '/qingguang/tenantbussiness/projectConfiguration/delete',
        method: 'post',
        data: data
    })
}

// 项目阶段模版配置 list
export function projectTemplatePhase_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/projectTemplatePhase/list',
        method: 'post',
        data: data
    })
}

// 项目阶段模版配置 add
export function projectTemplatePhase_add(data) {
    return request({
        url: '/qingguang/tenantbussiness/projectTemplatePhase/add',
        method: 'post',
        data: data
    })
}

// 项目阶段模版配置 update
export function projectTemplatePhase_update(data) {
    return request({
        url: '/qingguang/tenantbussiness/projectTemplatePhase/update',
        method: 'post',
        data: data
    })
}

// 项目阶段模版配置 delete
export function projectTemplatePhase_delete(data) {
    return request({
        url: '/qingguang/tenantbussiness/projectTemplatePhase/delete',
        method: 'post',
        data: data
    })
}

// 项目明细 list 
export function projectManagement_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/projectManagement/list',
        method: 'post',
        data: data
    })
}

// 项目明细 add
export function projectManagement_add(data) {
    return request({
        url: '/qingguang/tenantbussiness/projectManagement/add',
        method: 'post',
        data: data
    })
}

// 项目明细 update
export function projectManagement_update(data) {    
    return request({
        url: '/qingguang/tenantbussiness/projectManagement/update',
        method: 'post',
        data: data
    })
}

// 项目明细 delete
export function projectManagement_delete(data) {
    return request({
        url: '/qingguang/tenantbussiness/projectManagement/delete',
        method: 'post',
        data: data
    })
}

// 项目明细 view
export function projectManagement_view(data) {
    return request({
        url: '/qingguang/tenantbussiness/projectManagement/view',
        method: 'get',
        params: data
    })
}

// 项目明细 check
export function projectManagement_check(data) {
    return request({
        url: '/qingguang/tenantbussiness/projectManagement/check',
        method: 'post',
        data: data
    })
}

// 项目明细 取消审核
export function projectManagement_cancellationCheck(data) {
    return request({
        url: '/qingguang/tenantbussiness/projectManagement/cancellationCheck',
        method: 'post',
        data: data
    })
}

// 项目明细 进度完成
export function projectManagement_completePhase(data) {
    return request({
        url: '/qingguang/tenantbussiness/projectManagement/completePhase',
        method: 'post',
        data: data
  })
}

// 项目明细 进度开始
export function projectManagement_setPhaseInProgress(data) {
    return request({
        url: '/qingguang/tenantbussiness/projectManagement/setPhaseInProgress',
        method: 'post',
        data: data
  })
}

// 项目明细 进度回滚
export function projectManagement_rollbackPhase(data) {
    return request({
        url: '/qingguang/tenantbussiness/projectManagement/rollbackPhase',
        method: 'post',
        data: data
  })
}

// 项目统计接口 statistics
export function projectManagement_statistics(data) {
    return request({
        url: '/qingguang/tenantbussiness/projectManagement/statistics',
        method: 'post',
        data: data
  })
}

// 项目明细 修改子表状态
export function projectPhase_setPhaseException(data) {
    return request({
        url: '/qingguang/tenantbussiness/projectPhase/setPhaseException',
        method: 'post',
        data: data
  })
}

// 项目明细 修改主表状态
export function projectManagement_updateStatus(data) {
    return request({
        url: '/qingguang/tenantbussiness/projectManagement/updateStatus',
        method: 'post',
        data: data
  })
}

// 新增项目关联产品
export function projectManagement_addProjectMaterial(data) {
    return request({
        url: '/qingguang/tenantbussiness/projectManagement/addProjectMaterial',
        method: 'post',
        data: data
    })
}

// 删除项目关联产品
export function projectManagement_deleteProjectMaterial(data) {
    return request({
        url: '/qingguang/tenantbussiness/projectManagement/deleteProjectMaterial',
        method: 'post',
        data: data
    })
}

// 新增项目关联BOM
export function projectManagement_addProjectBom(data) {
    return request({
        url: '/qingguang/tenantbussiness/projectManagement/addProjectBom',
        method: 'post',
        data: data
    })
}

// 删除项目关联BOM
export function projectManagement_deleteProjectBom(data) {
    return request({
        url: '/qingguang/tenantbussiness/projectManagement/deleteProjectBom',
        method: 'post',
        data: data
    })
}

// 批量关联产品与项目
export function projectManagement_batchAddProjectMaterial(data) {
    return request({
        url: '/qingguang/tenantbussiness/projectManagement/batchAddProjectMaterial',
        method: 'post',
        data: data
    })
}

// 批量关联BOM与项目
export function projectManagement_batchAddProjectBom(data) {
    return request({
        url: '/qingguang/tenantbussiness/projectManagement/batchAddProjectBom',
        method: 'post',
        data: data
    })
}

// 查询项目关联的产品列表
export function projectManagement_getProjectMaterialList(data) {
    return request({
        url: '/qingguang/tenantbussiness/projectManagement/getProjectMaterialList',
        method: 'post',
        data: data
    })
}

// 查询项目关联的BOM列表
export function projectManagement_getProjectBomList(data) {
    return request({
        url: '/qingguang/tenantbussiness/projectManagement/getProjectBomList',
        method: 'post',
        data: data
    })
}

// 项目跟进记录 list
export function projectFollowUpRecord_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/projectFollowUpRecord/list',
        method: 'post',
        data: data
    })
}

// 项目跟进记录 add
export function projectFollowUpRecord_add(data) {
    return request({
        url: '/qingguang/tenantbussiness/projectFollowUpRecord/add',
        method: 'post',
        data: data
    })
}

// 项目跟进记录 update
export function projectFollowUpRecord_update(data) {
    return request({
        url: '/qingguang/tenantbussiness/projectFollowUpRecord/update',
        method: 'post',
        data: data
    })
}

// 项目跟进记录 delete
export function projectFollowUpRecord_delete(data) {
    return request({
        url: '/qingguang/tenantbussiness/projectFollowUpRecord/delete',
        method: 'post',
        data: data
    })
}


// 项目预算表 list
export function projectBudget_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/projectBudget/list',
        method: 'post',
        data: data,
    })
}

// 项目预算表 add
export function projectBudget_add(data) {
    return request({
        url: '/qingguang/tenantbussiness/projectBudget/add',
        method: 'post',
        data: data,
    })
}

// 项目预算表 update
export function projectBudget_update(data) {
    return request({
        url: '/qingguang/tenantbussiness/projectBudget/update',
        method: 'post',
        data: data,
    })
}

// 项目预算表 delete
export function projectBudget_delete(data) {
    return request({
        url: '/qingguang/tenantbussiness/projectBudget/delete',
        method: 'post',
        data: data,
    })
}

// 项目成员表 list
export function projectMember_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/projectMember/list',
        method: 'post',
        data: data,
    })
}

// 项目成员表 add
export function projectMember_add(data) {
    return request({
        url: '/qingguang/tenantbussiness/projectMember/add',
        method: 'post',
        data: data,
    })
}

// 项目成员表 update
export function projectMember_update(data) {
    return request({
        url: '/qingguang/tenantbussiness/projectMember/update',
        method: 'post',
        data: data,
    })  
}

// 项目成员表 delete
export function projectMember_delete(data) {
    return request({
        url: '/qingguang/tenantbussiness/projectMember/delete',
        method: 'post',
        data: data,
    })
}

// 获取当前项目的采购单所有物料
export function projectManagement_getProjectPurchaseMaterial(data) {
    return request({
        url: '/qingguang/tenantbussiness/projectManagement/getProjectPurchaseMaterial',
        method: 'post',
        data: data,
    })
}

// 费用表 list
export function projectExpense_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/projectExpense/list',
        method: 'post',
        data: data,
    })
}

// 费用表 add
export function projectExpense_add(data) {
    return request({
        url: '/qingguang/tenantbussiness/projectExpense/add',
        method: 'post',
        data: data,
    })
}

// 费用表 update
export function projectExpense_update(data) {
    return request({
        url: '/qingguang/tenantbussiness/projectExpense/update',
        method: 'post',
        data: data,
    })
}

// 费用表 delete
export function projectExpense_delete(data) {
    return request({
        url: '/qingguang/tenantbussiness/projectExpense/delete',
        method: 'post',
        data: data,
    })
}

// 规则制度确认收到
export function informNotice_confirmReceived(data) {
    return request({
        url: '/qingguang/tenantbussiness/informNotice/confirmReceived',
        method: 'post',
        data: data,
    })
}

// 规则制度上报已读
export function informNotice_markAsRead(data) {
    return request({
        url: '/qingguang/tenantbussiness/informNotice/markAsRead',
        method: 'post',
        data: data,
    })
}

// 规则制度确认状态列表
export function informNotice_getEmployeeStatusList(data) {
    return request({
        url: '/qingguang/tenantbussiness/informNotice/getEmployeeStatusList',
        method: 'post',
        data: data,
    })
}

// ai会话 list
export function aiChatSession_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/aiChatSession/list',
        method: 'post',
        data: data,
    })
}

// ai会话 add
export function aiChatSession_add(data) {
    return request({
        url: '/qingguang/tenantbussiness/aiChatSession/add',
        method: 'post',
        data: data,
    })
}

// ai会话 update
export function aiChatSession_update(data) {
    return request({
        url: '/qingguang/tenantbussiness/aiChatSession/update',
        method: 'post',
        data: data,
    })
}

// ai会话 delete
export function aiChatSession_delete(data) {
    return request({
        url: '/qingguang/tenantbussiness/aiChatSession/delete',
        method: 'post',
        data: data,
    })
}

// ai会话 view
export function aiChatSession_view(data) {
    return request({
        url: '/qingguang/tenantbussiness/aiChatSession/view',
        method: 'get',
        params: data,
    })
}

// AI模型计费列表
export function aiTokenStatistics_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/aiTokenStatistics/list',
        method: 'post',
        data: data,
    })
}

// 根据产品ID和规格ID查询采购规则里的采购员信息 
export function sysPurchaseRuleConfig_getPurchaserByMaterialAndSpec(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysPurchaseRuleConfig/getPurchaserByMaterialAndSpec',
        method: 'post',
        data: data,
    })
}


// 更新销单的项目
export function smgtSalesOrderDoc_updateProjectInfo(data) {
    return request({
        url: '/qingguang/tenantbussiness/smgtSalesOrderDoc/updateProjectInfo',
        method: 'post',
        data: data,
    })
}

// 更新采单的项目
export function pmgtPurchasesOrderDoc_updateProjectInfo(data) {
    return request({
        url: '/qingguang/tenantbussiness/pmgtPurchasesOrderDoc/updateProjectInfo',
        method: 'post',
        data: data,
    })
}

// 更新生产单的项目
export function produceDoc_updateProjectInfo(data) {
    return request({
        url: '/qingguang/tenantbussiness/produceDoc/updateProjectInfo',
        method: 'post',
        data: data,
    })
}

// 更新报销单的项目
export function reimburseDoc_updateProjectInfo(data) {
    return request({
        url: '/qingguang/tenantbussiness/reimburseDoc/updateProjectInfo',
        method: 'post',
        data: data,
    })
}

// 更新请款单的项目
export function requestFunds_updateProjectInfo(data) {
    return request({
        url: '/qingguang/tenantbussiness/requestFunds/updateProjectInfo',
        method: 'post',
        data: data,
    })
}

// 更新维修订单的项目
export function smgtAfterSalesRepairDoc_updateProjectInfo(data) {
    return request({
        url: '/qingguang/tenantbussiness/smgtAfterSalesRepairDoc/updateProjectInfo',
        method: 'post',
        data: data,
    })
}

// 更新售后订单的项目
export function afterSalesSituation_updateProjectInfo(data) {
    return request({
        url: '/qingguang/tenantbussiness/afterSalesSituation/updateProjectInfo',
        method: 'post',
        data: data,
    })
}

// 更新委外订单的项目
export function outsourcingDoc_updateProjectInfo(data) {
    return request({
        url: '/qingguang/tenantbussiness/outsourcingDoc/updateProjectInfo',
        method: 'post',
        data: data,
    })
}

// 更新工序委外的接口
export function processOutsourcing_updateProjectInfo(data) {
    return request({
        url: '/qingguang/tenantbussiness/processOutsourcing/updateProjectInfo',
        method: 'post',
        data: data,
    })
}


// 映射列表
export function sysDocExtControl_getCascadeableExtTypes(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysDocExtControl/getCascadeableExtTypes',
        method: 'get',
        params: data,
    })
}

// 显示组织接口
export function sys_currentOrganization(data) {
    return request({
        url: '/qingguang/tenantbussiness/sys/currentOrganization',
        method: 'get',
        params: data,
    })
}

// 切换组织接口
export function sys_switchOrganization(data) {
    return request({
        url: '/qingguang/tenantbussiness/sys/switchOrganization',
        method: 'post',
        data: data,
    })
}

// 保存流程
export function sysFlowProgress_saveConfig(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysFlowProgress/saveConfig',
        method: 'post',
        data: data,
    })
}


// 获取流程
export function sysFlowProgress_getConfig(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysFlowProgress/getConfig',
        method: 'post',
        data: data,
    })
}

// 本租户绑定设备列表
export function hardwareBinding_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/hardwareBinding/list',
        method: 'post',
        data: data,
    })
}

// 本租户绑定设备详情
export function hardwareBinding_licenseInfo(data) {
    return request({
        url: '/qingguang/tenantbussiness/hardwareBinding/licenseInfo',
        method: 'post',
        data: data,
    })
}

// 本租户解绑设备
export function hardwareBinding_unbind(data) {
    return request({
        url: '/qingguang/tenantbussiness/hardwareBinding/unbind',
        method: 'post',
        data: data,
    })
}

// 删除记录列表 
export function sysDeletionRecord_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysDeletionRecord/list',
        method: 'post',
        data: data,
    })
}

// 一键同步
export function sys_checkInitialization(data) {
    return request({
        url: '/qingguang/tenantbussiness/sys/checkInitialization',
        method: 'post',
        data: data,
    })
}

// 消息忽略配置 list
export function sysUserMessageIgnoreRule_list(data) {
    return request({
        url: '/admin/upms/sysUserMessageIgnoreRule/list',
        method: 'post',
        data: data,
    })
}

// 消息忽略配置 add
export function sysUserMessageIgnoreRule_add(data) {
    return request({
        url: '/admin/upms/sysUserMessageIgnoreRule/add',
        method: 'post',
        data: data,
    })
}

// 消息忽略配置 update

export function sysUserMessageIgnoreRule_update(data) {
    return request({
        url: '/admin/upms/sysUserMessageIgnoreRule/update',
        method: 'post',
        data: data,
    })
}

// 消息忽略配置 delete
export function sysUserMessageIgnoreRule_delete(data) {
    return request({
        url: '/admin/upms/sysUserMessageIgnoreRule/delete',
        method: 'post',
        data: data,
    })
}

// sn生成结果查询
export function produceDoc_listSnRecords(data) {
    return request({
        url: '/qingguang/tenantbussiness/produceDoc/listSnRecords',
        method: 'post',
        data: data,
    })
}

// 查询报工可选SN
export function produceDoc_listReportSelectableSn(data) {
    return request({
        url: '/qingguang/tenantbussiness/produceDoc/listReportSelectableSn',
        method: 'post',
        data: data,
    })
}

// 查询完工可选SN
export function produceDoc_listFinishSelectableSn(data) {
    return request({
        url: '/qingguang/tenantbussiness/produceDoc/listFinishSelectableSn',
        method: 'post',
        data: data,
    })
}